import { render, staticRenderFns } from "./CatAvatar.vue?vue&type=template&id=1fceba9b&"
import script from "./CatAvatar.vue?vue&type=script&lang=js&"
export * from "./CatAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CatAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/comte/Documents/CatMash-App/CatMash/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VAvatar,VProgressCircular})
